var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notifications",
    d: "M54.5455 48.5714V51.4286H5.45455V48.5714L10.9091 42.8571V25.7143C10.9091 16.8571 16.4455 9.05714 24.5455 6.54286C24.5455 6.25714 24.5455 6 24.5455 5.71429C24.5455 4.19876 25.1201 2.74531 26.1431 1.67368C27.166 0.602039 28.5534 0 30 0C31.4466 0 32.834 0.602039 33.8569 1.67368C34.8799 2.74531 35.4545 4.19876 35.4545 5.71429C35.4545 6 35.4545 6.25714 35.4545 6.54286C43.5545 9.05714 49.0909 16.8571 49.0909 25.7143V42.8571L54.5455 48.5714ZM35.4545 54.2857C35.4545 55.8012 34.8799 57.2547 33.8569 58.3263C32.834 59.398 31.4466 60 30 60C28.5534 60 27.166 59.398 26.1431 58.3263C25.1201 57.2547 24.5455 55.8012 24.5455 54.2857M51.1364 3.4L47.2636 7.45714C51.9273 12.2857 54.5455 18.8571 54.5455 25.7143H60C60 17.3429 56.8364 9.28571 51.1364 3.4ZM0 25.7143H5.45455C5.45455 18.8571 8.07273 12.2857 12.7364 7.45714L8.86364 3.4C3.16364 9.28571 0 17.3429 0 25.7143Z",
    fill: "#004D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.fb95acb8e66652d32d87cc819ab91145.svg";
export { ForwardRef as ReactComponent };